import { useEffect, useState } from 'react'
import handleApiCall from 'api/handleApiCall'
import { TellitLoader } from 'components/common'
import MiniAudioPlayer from 'modules/shared/MiniPlayer'

type RecordingProps = {
  data: any
}

const Recording = ({ data }: RecordingProps): JSX.Element => {

  const [isMediaLoading, setIsMediaLoading] = useState<boolean>(false)
  const [mediaSource, setMediaSource] = useState<any>(undefined)

  const getMedia = (): void => {
    setIsMediaLoading(true)
    void handleApiCall({
      urlType: 'getCallRecording',
      auth: true,
      // testAdminAccount: true,
      urlParams: `&media_id=${data.audio}`,
      cb: (res: any, state: boolean) => {
        if (res?.data !== undefined && state) {
          const decodedData = atob(res.data)
          // Create a typed array from the decoded string
          const arrayBuffer = new Uint8Array(decodedData?.length)
          for (let i = 0; i < decodedData.length; i++) {
            arrayBuffer[i] = decodedData.charCodeAt(i)
          }
          // Create Blob object
          const blob = new Blob([arrayBuffer], { type: 'audio/mp3' })
          // Create URL for the Blob object
          const url = URL.createObjectURL(blob)
          // set url
          setMediaSource(url)
        } else {
          if (res?.messge !== '') {
            // handleToastMessage(res.messge)
          }
        }
        setIsMediaLoading(false)
      }
    })
  }

  useEffect(() => {
    console.log('data', data)
    getMedia()
  }, [data])

  function getName(data: any): string {
    const name = data.name?.replace('+46', '0').replace(/^46/, '0')
    if (name === data.number || name === '') {
      return ''
    } else {
      return name + ' - '
    }
  }

  return (
    <>
      <TellitLoader loading={isMediaLoading}>
        {mediaSource !== undefined && (
          <div className={`flex flex-col items-center rounded-lg pt-4 shadow-lg bg-gray-100`}>
            {/* Call Metadata */}
            <div className="text-center">
              <p className="text-md font-semibold">
                {getName(data) + data.number}
              </p>
              <p className="text-md">{data.callDate}</p>
            </div>

            {/* Audio Player */}
            <MiniAudioPlayer src={mediaSource} />
            {/* <audio controls className="h-[54px]">
              <source src={mediaSource} type="audio/mp3" />
            </audio> */}
          </div>
        )}
      </TellitLoader>
    </>
  )
}

export default Recording
